import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeGeneralOnboardingModal() {
    return import(/* webpackChunkName: "TradeGeneralOnboardingModalChunk" */
    './TradeGeneralOnboardingModal').then(moduleExport => moduleExport.TradeGeneralOnboardingModal);
}

export const launchTradeGeneralOnboarding = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeGeneralOnboardingModal,
        containerClassName: 'tradeGeneralOnboardingContainer',
    });

    return dispatch({ type: customActionType.actionType });
};
